import { createControlComponent } from './core';
// import { Control } from '@anlan/gs-map';
import L from '@anlan/gs-map';
import type { Control as LeafletControl, ControlOptions } from '@anlan/gs-map';
const Control = L.Control;
export const ScaleControl = createControlComponent(function createScaleControl(props: ControlOptions): LeafletControl {
    return new Control.Scale(props);
});
